import { Link } from "react-router-dom"

const DESTINATIONS = [
  { name: "Lonavala", path: "/villas-in-lonavala" },
  { name: "Karjat", path: "/villas-in-karjat" },
  { name: "Alibag", path: "/villas-in-alibag" },
  { name: "Igatpuri", path: "/villas-in-igatpuri" },
  { name: "Panchgani", path: "/villas-in-panchgani" },
  { name: "Neral", path: "/villas-in-neral" },
]

const Footer = () => {
  return (
    <footer className="bg-black text-white mt-16">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Destinations Column — key for SEO internal linking */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Destinations</h3>
            <ul className="space-y-2">
              {DESTINATIONS.map((d) => (
                <li key={d.path}>
                  <Link
                    to={d.path}
                    className="text-gray-300 hover:text-white"
                  >
                    Villas in {d.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Explore Column */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Explore</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/explore" className="text-gray-300 hover:text-white">
                  All Villas
                </Link>
              </li>
              <li>
                <Link to="/offers" className="text-gray-300 hover:text-white">
                  Special Offers
                </Link>
              </li>
              <li>
                <Link to="/for-owner" className="text-gray-300 hover:text-white">
                  List Your Villa
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Column */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Company</h3>
            <ul className="space-y-2">
              <li>
                <span className="text-gray-500 cursor-not-allowed">
                  About Us (Coming Soon)
                </span>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white">
                  Contact Us
                </Link>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/villakosh.in"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-gray-300 hover:text-white"
                >
                  Instagram
                </a>
              </li>
              <li>
                <a
                  href="mailto:contact@villakosh.in"
                  className="text-gray-300 hover:text-white"
                >
                  Email Us
                </a>
              </li>
            </ul>
          </div>

          {/* Legal Column */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Legal</h3>
            <ul className="space-y-2">
              <li>
                <span className="text-gray-500 cursor-not-allowed">
                  Terms &amp; Conditions (Coming Soon)
                </span>
              </li>
              <li>
                <span className="text-gray-500 cursor-not-allowed">
                  Privacy Policy (Coming Soon)
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <Link to="/" className="text-2xl font-bold text-white">
              VillaKosh
            </Link>
            <p className="text-gray-400 text-sm mt-1">
              Premium villa stays in Maharashtra
            </p>
          </div>
          <div className="text-gray-400 text-sm">
            © 2026 VillaKosh. All Rights Reserved.
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
